export default html => window.pug.compile(html)();
